import { Button, Stack, Surface, Text } from "../primitives/index.ts";
import { useT } from "../i18n/I18nProvider.tsx";

export type AnalyticsConsentProps = {
  onAccept: () => void;
  onDecline: () => void;
  /** Where the answer can be changed later: Settings → Preferences (when the app has Settings) or the profile menu (default). */
  changeLaterIn?: "settings" | "profileMenu";
};

/**
 * One-time usage-analytics question (GA4 with consent mode: nothing loads until "Allow"). Both answers are equally
 * prominent; the choice can be changed later in Settings → Preferences, or from the profile menu where there is no
 * Settings screen (`changeLaterIn`). The host places it (web: bottom of the window).
 */
export function AnalyticsConsent({ onAccept, onDecline, changeLaterIn = "profileMenu" }: AnalyticsConsentProps) {
  const t = useT();
  return (
    <Surface material="elevated" width="dialog" padding="4" radius="lg" testID="analytics-consent">
      <Stack gap="3">
        <Text variant="headline">{t("consent.analytics.title")}</Text>
        <Text variant="footnote" color="text.secondary">
          {changeLaterIn === "settings" ? t("consent.analytics.messageSettings") : t("consent.analytics.message")}
        </Text>
        <Stack direction="horizontal" gap="2" justify="end" wrap>
          <Button label={t("consent.analytics.decline")} variant="secondary" size="sm" onPress={onDecline} testID="analytics-consent-decline" />
          <Button label={t("consent.analytics.accept")} variant="secondary" size="sm" onPress={onAccept} testID="analytics-consent-accept" />
        </Stack>
      </Stack>
    </Surface>
  );
}
